import { useState } from "react";
import { Tabs } from "../../../../components/common/Tabs";
import { useTheme } from "../../../../components/hooks/useTheme";
import { GeneralSettings } from "./GeneralSettings";
import { MaintenanceTypes } from "./maintenanceTypes/MaintenanceTypes";
import { DamageTypes } from "./damageTypes/DamageTypes";
import { ExpenseTypes } from "./expenseTypes/ExpenseTypes";

const tabs = [
  {
    label: "General Settings",
  },
  {
    label: "Maintenance Types",
  },
  {
    label: "Damage Types",
  },
  {
    label: "Expense Types",
  },
]

export const Maintenance = () => {
  const { themeStyles } = useTheme();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <h1 className={`m-1 ${themeStyles.main.textHeadingColor}`}>Maintenance Settings</h1>
        <div className="w-full my-2">
          <Tabs tabs={tabs} onChange={(index) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          {
            activeIndex === 0 && (
              <GeneralSettings />
            )
          }
          {
            activeIndex === 1 && (
              <MaintenanceTypes />
            )
          }
          {
            activeIndex === 2 && (
              <DamageTypes />
            )
          }
          {
            activeIndex === 3 && (
              <ExpenseTypes />
            )
          }
        </div>
      </div>
    </div>
  )
}

